import { defineComponent, ref, onMounted, openBlock, createElementBlock } from "vue";
import { useIntersectionObserver } from "../../composables/IntersectionObserver/useIntersectionObserver.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "VisibilityTracker",
  props: {
    linkName: {},
    disconnect: {
      type: Boolean,
      default: true
    }
  },
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const rootRef = ref();
    onMounted(() => {
      const {
        addIntersectionAction,
        observer
      } = useIntersectionObserver();
      if (rootRef.value) {
        addIntersectionAction(rootRef.value, (entry) => {
          var _a;
          if (entry.isIntersecting) {
            emit("metricsClick", {
              linkName: props.linkName
            });
            (_a = observer.value) == null ? void 0 : _a.disconnect();
          }
        });
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "rootRef",
        ref: rootRef
      }, null, 512);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=VisibilityTracker.mjs.map
